import { EventBroker } from "@frontend/lib/utils/event-broker";

export const WALMART_EVENTS = {
    REPORT_INIT: 'REPORT_INIT',
};

export const walmartEventBroker = new EventBroker();
